import { Button, Grid, Group, TextInput, NumberInput, Select } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { useForm } from '@mantine/form';

import { useAppSelector, selectUserRoles } from '@/shared';
import { userRoleTitles } from '@/shared/utils/helpers/common';
import { transformDateFilter } from '@/shared/utils/helpers/datetime-format';
import { CustomCollapse } from '@/shared';

import type { TGetUsers } from '../store/types';

type FormData = TGetUsers;
type Props = {
  onSubmit: (data: TGetUsers) => void;
  onReset: () => void;
};

export const UsersFilter = (props: Props) => {
  const { onSubmit, onReset } = props;
  const userRoles = useAppSelector(selectUserRoles);

  const form = useForm<FormData>({
    mode: 'uncontrolled',
    initialValues: {},
  });

  const handleSubmit = (values: FormData) => {
    const newValues: TGetUsers = {
      ...values,
      createdFrom: values.createdFrom ? transformDateFilter(values.createdFrom).dateFrom : undefined,
      createdTo: values.createdTo ? transformDateFilter(values.createdTo).dateTo : undefined,
    };

    onSubmit(newValues);
  };

  const handleReset = () => {
    form.reset();
    onReset();
  };

  return (
    <CustomCollapse title="Фильтр">
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Grid>
          <Grid.Col span={{ base: 12, md: 4 }}>
            {/* Первая секция */}
            <NumberInput
              label="ID пользователя"
              placeholder=""
              key={form.key('id')}
              {...form.getInputProps('id')}
            />
            <TextInput
              label="Email"
              placeholder=""
              key={form.key('email')}
              {...form.getInputProps('email')}
            />
            <Group justify='space-between' grow>
              <DatePickerInput
                valueFormat="DD.MM.YYYY"
                label="Дата (от)"
                placeholder=""
                clearable
                key={form.key('createdFrom')}
                {...form.getInputProps('createdFrom')}
              />
              <DatePickerInput
                valueFormat="DD.MM.YYYY"
                label="Дата (до)"
                placeholder=""
                clearable
                key={form.key('createdTo')}
                {...form.getInputProps('createdTo')}
              />
            </Group>
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 4 }}>
            {/* Вторая секция */}
            <TextInput
              label="Телефон"
              placeholder=""
              key={form.key('phone')}
              {...form.getInputProps('phone')}
            />
            <TextInput
              label="Имя"
              placeholder=""
              key={form.key('name')}
              {...form.getInputProps('name')}
            />
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 4 }}>
            {/* Третья секция */}
            <Select
              label="Роль"
              placeholder=""
              clearable
              data={userRoles.map((userRole) => ({ value: userRole, label: userRoleTitles[userRole] ?? userRole }))}
              key={form.key('role')}
              {...form.getInputProps('role')}
            />
            <Group justify="flex-end" mt="25">
              <Button variant="outline" onClick={handleReset}>
                Сбросить
              </Button>
              <Button type="submit">
                Отправить
              </Button>
            </Group>
          </Grid.Col>
        </Grid>
      </form>
    </CustomCollapse>
  );
};
